import axios from "axios";
import refreshToken from "./RefreshTokenApi";
import { Mixpanel } from "../utils/Mixpanel";

const idApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_AUTH_HOST}/api/v1`,
    withCredentials: true,
    headers: {
        "Content-type": "application/json",
    },
});

idApi.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

idApi.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;
        if (!err.response) {
            Mixpanel.track("UI IDP API Unresponsive - network error to /" + originalConfig.url);
        }
        if (err.response && originalConfig.url !== "auth/refresh") {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;
                try {
                    // the refresh token should be passed in via the cookie
                    await refreshToken.getAccessToken();
                    return idApi(originalConfig);
                } catch (_error) {
                    // TODO I removed this as I was getting 500 errors refreshing the token. But the log out isn't perfect and should really redirect to the logout page or something
                    // remove their cookies if they don't have a valid refresh token
                    //TokenService.logoutUser();
                    return Promise.reject(_error);
                }
            }
        }

        return Promise.reject(err);
    }
);

export default idApi;
